import originHelper from './originHelper';

const buildIframeLoadedMessageHandler = ({
  allowedOrigin,
  listenerKey,
  selector,
  onLoadSendData,
  resolve,
  pendingIframeLoadedListeners,
}) => {
  const handler = (event) => {
    if (event.origin !== allowedOrigin) return;

    const message = event.data;

    if (message.data && message.data.uniqueId === listenerKey && message.action === 'IFRAME_LOADED') {
      window.removeEventListener('message', handler);
      pendingIframeLoadedListeners.delete(listenerKey);
      resolve(`loaded iframe${selector} with uniqueId ${onLoadSendData.uniqueId }`);
    }
  };

  return handler;
};

const resolveIframePromiseOnLoaded = (resolve, options, jsHost, pendingIframeLoadedListeners) => {
  const { onLoadSendData, selector } = options;
  const listenerKey = onLoadSendData.uniqueId;
  const allowedOrigin = originHelper.allowedOriginFromJsHost(jsHost);
  const iframeLoadedMessageHandler = buildIframeLoadedMessageHandler({
    allowedOrigin,
    listenerKey,
    selector,
    onLoadSendData,
    resolve,
    pendingIframeLoadedListeners,
  });

  window.addEventListener('message', iframeLoadedMessageHandler);
  pendingIframeLoadedListeners.set(listenerKey, iframeLoadedMessageHandler);
};

export default {
  resolveIframePromiseOnLoaded,
};
